import { render, staticRenderFns } from "./MouseIcon.vue?vue&type=template&id=1820b97e"
import script from "./MouseIcon.vue?vue&type=script&lang=js"
export * from "./MouseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports